module.exports = __webpack_public_path__ + "static/media/LifeLine5.33c047ef.png";